import dayjs from 'dayjs'

export const isMarkdownRemark = (node) =>
  node?.internal?.type === 'MarkdownRemark'
export const isSanityBlogPost = (node) =>
  node?.internal?.type === 'SanityBlogPost'
export const isSanityAskAnvil = (node) =>
  node?.internal?.type === 'SanityAskAnvil'
export const isSanityPodcastPage = (node) =>
  node?.internal?.type === 'SanityPodcastPage'

export const getPublishDate = ({ airtablePublishDate }) => {
  return airtablePublishDate ? dayjs(airtablePublishDate) : dayjs()
}

export const getModifiedDate = ({
  airtableModifiedDate,
  airtablePublishDate,
}) => {
  return airtableModifiedDate
    ? dayjs(airtableModifiedDate)
    : getPublishDate({ airtablePublishDate })
}

export function sortPosts (a, b) {
  if (a.modifiedDate && b.modifiedDate) {
    return new Date(b.modifiedDate) - new Date(a.modifiedDate)
  }

  return new Date(b.publishDate) - new Date(a.publishDate)
}
